import { render, staticRenderFns } from "./SectionInfoAndImage.vue?vue&type=template&id=24d33156&"
import script from "./SectionInfoAndImage.vue?vue&type=script&lang=js&"
export * from "./SectionInfoAndImage.vue?vue&type=script&lang=js&"
import style0 from "./SectionInfoAndImage.vue?vue&type=style&index=0&id=24d33156&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonAtomLinesBullet: require('/app/components/atoms/common/AtomLinesBullet.vue').default})
